// Load webfonts
// Load components
import '../utils/device-detector';
// 36Volt V2
import './36-volt-v2/init-carousels';
import './36v-nav';
import './accordions';
import './activities';
import './animation-of-fall';
import './automotive/automotive';
import './automotive/automotive-scroll';
import './blog';
import './call-flexslider';
import './call-slick';
import './caroufredsel';
import './checkboxes';
import './compare-viewer';
import './competition-form';
import './contact-form';
import './cookie-popup';
import './country-drop';
import './detect-device';
import './equalise-heights';
import './error404';
import './fancybox';
import './fr-blogger/blogger-main';
import './fr-blogger/fr-blogger-scroll-anim';
import './high-energy';
import './homepage-popout/homepage-popout';
import './image-upload-form';
import './init-accordion-automotive';
import './init-browser-detection';
import './init-brushless-animation';
import './init-brushless-scroll';
import './init-brushless-scrollmagic';
import './init-device-detection';
import './init-fullscreen-popup';
import './init-generic-popup';
import './init-home-promos';
import './init-match-height';
import './init-media-carousel';
import './init-newsletter-slider';
import './init-store-popups';
import './init-text-fill';
import './init-video-controls';
import './init-win-v2-analytics';
import './insights-detail';
import './move-compare';
import './my-account/index';
import './one-plus-v2/init-accordion';
import './one-plus-v2/init-animations';
import './one-plus-v2/init-carousels';
// One Plus V2
import './one-plus-v2/init-gallery';
import './one-plus/button-toggle';
import './one-plus/carousel';
import './one-plus/init-accordion-one-plus';
import './one-plus/init-scroll-magic';
import './one-plus/init-smoth-scroll';
import './one-plus/init-tabs-carousel';
import './page-loaded';
import './phoneworks/phoneworks';
// Load components, were previously in /sitefiles/shared/...
import './placeholder';
import './product-data-popup';
import './product-detail/accessories';
import './product-detail/application-images';
import './product-detail/attribute-sets';
import './product-detail/featured-section';
import './product-detail/features';
import './product-detail/gallery';
import './product-detail/header-details';
import './product-detail/product-extra-info';
import './product-detail/product-nav';
import './product-detail/reviews';
import './product-detail/support';
import './product-detail/tabbed-area';
import './product-detail/videos';
import './promo-page-main';
import './promo-pods';
import './quickmow';
import './roboyagi';
// Load legacy scripts.
import './scripts';
import './scroll-top';
import './search-autocomplete';
import './select-menu';
import './share-popup';
import './subscription-lightbox';
import './tables';
import './tabs';
import './terms';
import './toolbox-competition';
import './webfonts';

if (
  document.querySelector('.js-blogger-project-filter') ||
  document.querySelector('.js-blogger-project-filter-form')
) {
  import(/* webpackChunkName: "choice" */ './init-choices');
}

if (document.querySelector('.js-lazy-load') && document.querySelector('.js-diy-submission')) {
  import(/* webpackChunkName: "diy" */ './init-diy');
}

if (document.querySelector('.js-sticky-nav-cta')) {
  import(/* webpackChunkName: "nav" */ './stickyNav');
}

if (document.querySelector('[data-anim]')) {
  import(/* webpackChunkName: "animation-framework" */ 'utils/Animations');
}

if (document.querySelector('.js-cta-subscribe')) {
  import(/* webpackChunkName: "open-subscription-form" */ './open-subscription-form');
}

if (document.querySelector('.js-video-container')) {
  import(/* webpackChunkName: "inlineVideo" */ './init-inline-video');
}

if (document.querySelector('.js-carousel')) {
  import(/* webpackChunkName: "image-carousel" */ './init-carousel');
}
